/**
 * Hook has been determining if the user is in the new activation flow experiment group
 *
 * Group A = control group (UnifiedActivationFlow flow only does pre-account onboarding)
 * Group B = experiment group (UnifiedActivationFlow flow does both pre-account onboarding and post-account activation)
 *
 * @returns boolean - true if user is in Group B
 *
 * UPDATE: now we enabled the experiment for all users, so this hook will always return true. We keep it as a hook in case we want to do some more complex logic in the future to determine if the user should see the new activation flow or not.
 */
export const useIsInActivationFlowExperiment = (): boolean => {
  return true;
};
